import { usePermission } from "../context/PermissionProvider";

const ActionPermission = ({ pageKey, action, children, fallback = null }) => {
  const { permissions } = usePermission();
  const key = pageKey?.toLowerCase();
  console.log(pageKey, action,);
  const allowedActions = permissions?.actions?.[key] || [];

  if (!allowedActions.includes(action)) {
    return fallback;
  }

  return children;
};

export default ActionPermission;
